import * as angular from 'angular';
import MenuService from './menu.service';
import MENU_CONSTANT from './menu.constant';

export default angular
  .module('MenuModule', [])
  .service('MenuService', MenuService)
  .constant('MENU_CONSTANT', MENU_CONSTANT)
  .name;



// WEBPACK FOOTER //
// ./src/app/shared/menu/menu.module.js